import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class AssetLoaderService {
  loadCss(id: string, href: string) {
    if (document.getElementById(id)) return

    const link = document.createElement('link')
    link.id = id
    link.rel = 'stylesheet'
    link.href = href

    document.head.appendChild(link)
  }

  loadScript(id: string, src: string) {
    if (document.getElementById(id)) return

    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = false

    document.body.appendChild(script)
  }

  remove(id: string) {
    document.getElementById(id)?.remove()
  }
}
